import { createSlice } from "@reduxjs/toolkit";
import { toggleLike, getMyLikes } from "./thunk";

const initialState = {
  likes: [],
  loading: false,
  error: null,
};

const likeSlice = createSlice({
  name: "like",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ========================
      // GET MY LIKES
      // ========================
      .addCase(getMyLikes.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMyLikes.fulfilled, (state, action) => {
        state.loading = false;
        state.likes = action.payload;
      })
      .addCase(getMyLikes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ========================
      // TOGGLE LIKE
      // ========================
      .addCase(toggleLike.pending, (state) => {
        state.loading = true;
      })
      .addCase(toggleLike.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(toggleLike.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default likeSlice.reducer;
